import React, { useEffect, useState } from "react";
import "./Popover.scss";
import Button from "../Button/Button";

const PopoverHandler = ({ className, label, icon, children }) => {
	const [showChildren, setShowChildren] = useState(false);

	const showContent = () => {
		setShowChildren(!showChildren);
	};

	return (
		<div className={`popover-handler ${className ? className : ""}`}>
			<Button className="button-tertiary" label={label} icon={icon} onClick={showContent} />
			{showChildren ? <>{<div onClick={showContent}>{children}</div>}</> : <></>}
		</div>
	);
};

export default PopoverHandler;
